export default function Testimonials() {
  const testimonials = [
    {
      quote: "After my car accident, I didn't know where to turn. As an immigrant, I was worried about my rights. Hong-min Jun and her team made me feel safe and fought hard for my compensation. They truly understand our community.",
      author: "Maria G.",
      case: "Car Accident Case",
      amount: "$285,000",
      label: "Settlement"
    },
    {
      quote: "I was injured at my construction job and my employer tried to deny my claim. The attorneys at this firm stood up for me and got me the workers' compensation I deserved. They even helped me in Spanish.",
      author: "Carlos M.",
      case: "Workplace Injury",
      amount: "$150,000",
      label: "Settlement"
    },
    {
      quote: "When my husband died due to medical malpractice, I thought I had no options as a non-citizen. This law office proved me wrong. They fought for justice for my family and won a significant settlement.",
      author: "Li W.",
      case: "Medical Malpractice",
      amount: "$1.2M",
      label: "Settlement"
    },
    {
      quote: "I slipped and fell at a grocery store and suffered serious injuries. The insurance company offered me almost nothing. Thanks to this firm, I received fair compensation that covered all my medical bills and lost wages.",
      author: "Raj P.",
      case: "Slip and Fall",
      amount: "$95,000",
      label: "Settlement"
    }
  ];

  return (
    <section id="testimonials" className="py-16 bg-lavender-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="mb-12 max-w-4xl">
          <p className="text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">Client Stories</p>
          <h2 className="text-6xl md:text-7xl font-light text-gray-900 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            Success<br />
            <span className="italic font-normal">Stories</span>
          </h2>
        </div>

        {/* Testimonials grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {testimonials.map((testimonial, index) => (
            <article key={index} className="border-t-2 border-gray-900 pt-8">
              <blockquote className="mb-8">
                <p className="text-xl font-light text-gray-800 leading-relaxed italic mb-6" style={{ fontFamily: "'Crimson Pro', serif" }}>
                  "{testimonial.quote}"
                </p>
              </blockquote>
              
              <div className="flex items-end justify-between border-t border-gray-200 pt-6">
                <div>
                  <p className="text-sm font-medium text-gray-900 mb-1" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {testimonial.author}
                  </p>
                  <p className="text-xs tracking-wider uppercase text-gray-500">
                    {testimonial.case}
                  </p>
                </div>
                <div className="text-right">
                  <div className="flex items-center gap-1 justify-end">
                    <span className="text-2xl font-light text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {testimonial.amount[0]}
                    </span>
                    <span
                      className="text-2xl font-light text-gray-900 select-none"
                      style={{ fontFamily: "'Playfair Display', serif", filter: 'blur(6px)', userSelect: 'none' }}
                    >
                      {testimonial.amount.slice(1)}
                    </span>
                    <span className="text-2xl font-light text-gray-900 ml-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {testimonial.label}
                    </span>
                  </div>
                  <p className="text-xs tracking-[0.2em] uppercase text-gray-400 mt-1">Confidential</p>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Bottom note */}
        <div className="mt-10 pt-8 border-t border-gray-200">
          <p className="text-xs text-gray-500 text-center italic" style={{ fontFamily: "'Inter', sans-serif" }}>
            Past results do not guarantee future outcomes. Each case is unique and results may vary.
          </p>
        </div>
      </div>
    </section>
  );
}
